<script setup>
import {ref, computed, watch} from 'vue'
import {useTimeAgo} from '@vueuse/core'
import {useComponentsStore} from '@/stores/components'
import {useItemDataStore} from '@/stores/itemData'
import UserAvatar from '@/common/UserAvatar'

const props = defineProps({
    item: {
        type: Object,
        required: true
    },
    getUserId: {
        type: Function,
        required: true
    },
    setUserId: {
        type: Function,
        required: true
    }
})

const componentsStore = useComponentsStore()
const itemDataStore = useItemDataStore()

const showAvatar = ref(false)
const title = ref('')

const timeAgo = useTimeAgo(props.item.createdDate * 1000)

const component = computed(() => componentsStore.items.find(obj => obj.id === props.item.componentId))
const nameField = computed(() => componentsStore.nameField(props.item.componentId))

const setShowAvatar = () => {
    const currentUserId = props.getUserId()
    if (!currentUserId || currentUserId !== props.item.createdBy) {
        showAvatar.value = true
        props.setUserId(props.item.createdBy)
    }
}

const goToItem = () => {
    const themesComponents = [
        'templates_templates',
        'themes_css',
        'themes_javascript',
        'themes_images',
        'themes_fonts',
    ]

    const path = themesComponents.includes(component.value.tableName)
        ? `/#/themes_editor/?section=${component.value.tableName}&id=${props.item.rowId}`
        : `/#/${component.value.tableName}/${props.item.rowId}`

    window.location = path
}

const fetchTitle = async () => {
    if (component.value) {
        try {
            const obj = await itemDataStore.get({
                tableName: component.value.tableName,
                id: props.item.rowId
            })
            title.value = obj[nameField.value]
        } catch (error) {
            console.error("Error fetching activity item title:", error)
        }
    }
}

setShowAvatar()

watch(() => [component.value, props.item.rowId], fetchTitle, {immediate: true})
</script>

<template>
    <div :class="{ 'mt-2': showAvatar }" class="position-relative">
        <UserAvatar
            v-if="showAvatar"
            class="position-absolute"
            :user-id="item.createdBy"
            :is-small="true"
            :tooltip-placement="'right'"
        />

        <div class="ms-4 ps-2 pt-1 small">
            <span v-if="item.componentId" class="breadcrumb mb-0" role="button" @click="goToItem">
                <span v-if="component" class="breadcrumb-item">{{ component.title }}</span>
                <span class="breadcrumb-item">{{ title }}</span>
            </span>
            <span v-else>
                {{ item.activity }}
            </span>

            <div>
                <small class="text-secondary">{{ timeAgo }}</small>
            </div>
        </div>
    </div>
</template>